var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",on:{"click":_vm.currImg}},[_c('div',{staticClass:"image",style:(("background-image: url('" + _vm.currentImage + "'); background-position: center; background-size: cover;"))})])}
var staticRenderFns = []

export { render, staticRenderFns }